export const convertToHtml = (text) => {
  if (!text) return '';
  if (text.includes('<br')) {
    return text;
  }
  // Replace each \n with <br />
  return text.replace(/\n/g, '<br />');
};
